module.exports = __webpack_public_path__ + "img/circle-2.b28a6c09.png";